import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import { ProductCategory } from "../../types/modules/productCategory.type";
import { getStoreAccessToken, getStoreId } from "../../utils/auth";

export const useProductCategories = (storeId?: number) => {
  const token = getStoreAccessToken();
  const storeIdToSend = storeId ? storeId : getStoreId();
  return useQuery({
    queryKey: ["product-categories", storeIdToSend],
    queryFn: () =>
      fetcher<ProductCategory[]>(`category/all/${storeIdToSend}`, token),
  });
};

export const useProductCategoriesForAction = (storeId?: number) => {
  const token = getStoreAccessToken();
  const storeIdToSend = storeId ? storeId : getStoreId();
  console.log({ storeIdToSend, storeId });
  return useQuery({
    queryKey: ["product-categories-for-action", storeIdToSend, token],
    queryFn: () =>
      fetcher<ProductCategory[]>(`category/all/${storeIdToSend}/action`, token),
  });
};
